import React, { Fragment, useContext, useEffect } from "react"
import { AppContext } from "../../../../components/AppProvider";
import { closeLayerFn } from "../../../Layout";

export default (props) => {
    const {saveAllergy, modAllergy, saveMode, foodId, searchMode} = props;
    const { userinfo } = useContext(AppContext);

    let date = new Date();
    let toYear = date.getFullYear();
    let fromYear = userinfo ? userinfo.birth.substring(0,4) : toYear
    let yearList = [];

    for(let i=fromYear; i<=toYear; i++) {
        yearList.push(i);
    }

    const closePopup = () => {
        $("input:radio[name='defaultList']").prop('checked', false);
        closeLayerFn($("#listDetailPopup"));
    }

    const timeCheckToggle = () => {
        if($("#timeCheck").is(":checked") == true) {
            $("#selectYear").css("display", "none");
            $("#selectMonth").css("display", "none");
        } else {
            $("#selectYear").css("display", "");
            $("#selectMonth").css("display", "");
        }          
    }

    return (
      <div className="blacklayer-container health-input-layer" id="listDetailPopup">
        <div className="bl-blind"></div>
        <div className="in-layerarea nobtn">
          <div className="blgrn-box priv">
            {searchMode != 0 && foodId && (foodId == "F90" || foodId == "E90") ? (
              <Fragment>
                <div className="blgr-title">기타</div>
                <div className="backword" style={{ paddingTop: "8px" }}>
                  <input
                    type="text"
                    id="addPopupTitle"
                    maxLength="20"
                    placeholder="알레르기 원인명을 입력하세요"
                    style={{
                      width: "100%",
                      height: "50px",
                      borderRadius: "8px",
                      border: "0px",
                      boxSizing: "border-box",
                      padding: "0 45px 0 15px",
                    }}
                  />
                </div>
              </Fragment>
            ) : (
              <Fragment>
                {/* <div className="blgr-title" id="addPopupTitle">알레르기 약품명</div> */}
                <div className="blgr-title" id="addPopupTitle">
                  {props.medicineText}
                </div>
              </Fragment>
            )}
            <input type="hidden" id="allergyId" value="" />
            <div className="health-input-contain">
              <div className="step-section">
                <div className="input-list">
                  <ul>
                    <li>
                      <div className="title">증상시점</div>

                      {/* 모름 Label */}
                      <input
                        type="checkbox"
                        id="timeCheck"
                        value=""
                        style={{ margin: "0 2vw 0.75vw 0", verticalAlign: "sub" }}
                        onClick={timeCheckToggle}
                      />
                      <label htmlFor="timeCheck" style={{ fontSize: "3.775vw", color: "#fff" }}>
                        모름
                      </label>

                      <div className="select-h">
                        {/* 년도 선택 */}
                        <div className="select-custom-box">
                          <a href={void 0} className="btn-select inb" id="selectYear">
                            {toYear}년
                          </a>
                          <ul style={{ height: "160px", overflow: "auto" }}>
                            {yearList &&
                              yearList.map((year, i) => (
                                <li key={i}>
                                  <a>{year}년</a>
                                </li>
                              ))}
                          </ul>
                        </div>

                        <div className="select-custom-box">
                          <a href={void 0} className="btn-select inb" id="selectMonth">
                            1월
                          </a>
                          <ul style={{ height: "160px", overflow: "auto" }}>
                            <li>
                              <a>1월</a>
                            </li>
                            <li>
                              <a>2월</a>
                            </li>
                            <li>
                              <a>3월</a>
                            </li>
                            <li>
                              <a>4월</a>
                            </li>
                            <li>
                              <a>5월</a>
                            </li>
                            <li>
                              <a>6월</a>
                            </li>
                            <li>
                              <a>7월</a>
                            </li>
                            <li>
                              <a>8월</a>
                            </li>
                            <li>
                              <a>9월</a>
                            </li>
                            <li>
                              <a>10월</a>
                            </li>
                            <li>
                              <a>11월</a>
                            </li>
                            <li>
                              <a>12월</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="title">증상여부</div>
                      <div className="backword">
                        <input
                          type="radio"
                          id="certain"
                          value="1"
                          name="symptomType"
                          style={{ verticalAlign: "sub" }}
                          defaultChecked
                        />
                        <label
                          htmlFor="certain"
                          style={{ margin: "0 2vw 0 2vw", fontSize: "3.775vw", color: "#fff" }}
                        >
                          확실
                        </label>
                        <input
                          type="radio"
                          id="suspect"
                          value="0"
                          name="symptomType"
                          style={{ verticalAlign: "sub" }}
                        />
                        <label
                          htmlFor="suspect"
                          style={{ margin: "0 2vw 0 2vw", fontSize: "3.775vw", color: "#fff" }}
                        >
                          의심
                        </label>
                      </div>
                    </li>

                    <li>
                      <div className="title">증상내용</div>
                      <div className="backword">
                        <input
                          type="text"
                          id="symptomInfo"
                          maxLength="20"
                          placeholder="증상내용을 입력해주세요"
                        />
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="tbns-area">
                  <a onClick={() => closePopup()} className="btn-round gray btn-cancel">
                    취소
                  </a>
                  <a
                    className="btn-round wht btn-next"
                    onClick={
                      saveMode === 0
                        ? () =>
                            saveAllergy(
                              $("#selectYear").text(),
                              $("#selectMonth").text(),
                              $("input[name='symptomType']:checked").val(),
                              $("#symptomInfo").val(),
                              foodId == "F90" || foodId == "E90"
                                ? $("#addPopupTitle").val()
                                : $("#addPopupTitle").text()
                            )
                        : () =>
                            modAllergy(
                              $("#selectYear").text(),
                              $("#selectMonth").text(),
                              $("input[name='symptomType']:checked").val(),
                              $("#symptomInfo").val()
                            )
                    }
                  >
                    등록
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};